define.alias("ember-cli-string-helpers/helpers/titleize", "calendar/helpers/titleize");